import React, {FC} from "react"
import styled from "styled-components"

import {FormattedMessage} from "@irati/utils/lang"
import {Card} from "@irati/ui/src/Layout"
import padding from "@irati/ui/src/global/padding"
import {Body} from "@irati/ui/src/Typography"
import {useTheme} from "@irati/ui/src/global/useTheme"

import image from "./no-results.png"

const ICON_SIZE = 90

const NoResultsIcon = styled.img.attrs({
  alt: "no results",
  width: `${ICON_SIZE}px`,
  height: `${ICON_SIZE}px`,
  src: image
})`
  margin-bottom: ${padding.tiny};
`

const Wrapper = styled(Card)`
  align-items: center;
  border-bottom: 1px solid ${({theme}) => theme.colors.greys.light};
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: ${padding.base};
  padding: 55px;
`

const NoResults: FC = () => {
  const theme = useTheme()

  return (
    <Wrapper>
      <NoResultsIcon />
      <Body small marginBottom={1} textAlign="center">
        <FormattedMessage id="reward.catalogue.noresults.title" />
      </Body>
      <Body small marginBottom={1} maxWidth="360px" textAlign="center" color={theme.colors.greys.medium}>
        <FormattedMessage id="reward.catalogue.noresults.body" />
      </Body>
    </Wrapper>
  )
}

export default NoResults
